import React, { useState, useEffect, useContext, useRef } from 'react'
import {
   Box,
   Button,
   Card,
   CardContent,
   CardHeader,
   Divider,
   TextField,
   Grid
} from '@material-ui/core'

// contexts
import { ToastContext } from '../../contexts/Toast'

// API
import { getPublicAPI, putPublicAPI } from '../../api'

const discounts = [
   { value: 0, label: '0' },
   { value: 5, label: '5' },
   { value: 10, label: '10' },
   { value: 15, label: '15' },
   { value: 20, label: '20' },
   { value: 25, label: '25' },
   { value: 30, label: '30' },
   { value: 35, label: '35' },
   { value: 40, label: '40' },
   { value: 45, label: '45' },
   { value: 50, label: '50' },
   { value: 55, label: '55' },
   { value: 60, label: '60' },
   { value: 65, label: '65' },
   { value: 70, label: '70' },
   { value: 75, label: '75' },
   { value: 80, label: '80' },
   { value: 85, label: '85' },
   { value: 90, label: '90' },
   { value: 95, label: '95' },
   { value: 100, label: '100' }
]

const CustomerProfileDetails = props => {
   let customerId = props?.customerid

   let mounted = useRef(true)
   const { setToasts } = useContext(ToastContext)
   const [values, setValues] = useState({
      name: '',
      email: '',
      phone: '',
      company: '',
      discountValue: 0
   })

   useEffect(() => {
      async function getUserData() {
         let userData = await getPublicAPI(`/user/${customerId}`)
         if (userData?.success) {
            setValues({
               name: userData.data.fName + ' ' + userData.data.lName,
               email: userData.data.email,
               phone: userData.data.phone,
               company: userData.data.company,
               discountValue: userData.data.discountValue
            })
         }
      }
      getUserData()
   }, [customerId])

   const handleChange = event => {
      mounted.current &&
         setValues({
            ...values,
            [event.target.name]: event.target.value
         })
   }

   const saveProfileDetails = async () => {
      const dataToSend = {
         discountValue: values.discountValue,
         customerId
      }
      let profileUpdated = await putPublicAPI(`/user`, dataToSend)
      if (profileUpdated?.success) {
         setValues({
            discount: profileUpdated.data.discountValue
         })
         setToasts({ type: 'success', messages: [{ msg: 'Discount value updated successfully' }] })
      } else {
         setToasts({ type: 'error', messages: [{ msg: 'Error in updating discount value' }] })
      }
   }

   return (
      <form autoComplete='off' noValidate {...props}>
         <Card>
            <CardHeader subheader='The discount value can be edited only' title='Profile' />
            <Divider />
            <CardContent>
               <Grid container spacing={3}>
                  <Grid item md={6} xs={12}>
                     <TextField
                        fullWidth
                        label='Name'
                        name='name'
                        onChange={handleChange}
                        required
                        value={values.name}
                        variant='outlined'
                        disabled
                     />
                  </Grid>
                  <Grid item md={6} xs={12}>
                     <TextField
                        fullWidth
                        label='Company'
                        name='company'
                        onChange={handleChange}
                        value={values.company}
                        variant='outlined'
                        disabled
                     />
                  </Grid>
                  <Grid item md={6} xs={12}>
                     <TextField
                        fullWidth
                        label='Email Address'
                        name='email'
                        onChange={handleChange}
                        required
                        disabled
                        value={values.email}
                        variant='outlined'
                     />
                  </Grid>
                  <Grid item md={6} xs={12}>
                     <TextField
                        fullWidth
                        label='Phone Number'
                        name='phone'
                        onChange={handleChange}
                        required
                        value={values.phone}
                        variant='outlined'
                        disabled
                     />
                  </Grid>
                  <Grid item md={12} xs={12}>
                     <TextField
                        fullWidth
                        label='Address'
                        name='address'
                        onChange={handleChange}
                        value={values.address}
                        variant='outlined'
                        disabled
                     />
                  </Grid>
                  <Grid item md={6} xs={12}>
                     <TextField
                        fullWidth
                        label='Set Discount Value'
                        name='discountValue'
                        onChange={handleChange}
                        required
                        select
                        SelectProps={{ native: true }}
                        value={values.discountValue}
                        variant='outlined'
                     >
                        {discounts.map(option => (
                           <option key={option.value} value={option.value}>
                              {option.label}
                           </option>
                        ))}
                     </TextField>
                  </Grid>
               </Grid>
            </CardContent>
            <Divider />
            <Box
               sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  p: 2
               }}
            >
               <Button color='primary' variant='contained' onClick={saveProfileDetails}>
                  Save details
               </Button>
            </Box>
         </Card>
      </form>
   )
}

export default CustomerProfileDetails
